import React from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { appData as portfolioData } from '../../../../data/portfolioData';
import { appData } from '../../../../data/appData';
import './Skills.css';

const Skills = () => {
  const { getText, currentLanguage } = useLanguage();
  
  // Obtener los datos de about del appData usando el idioma actual
  const aboutData = appData.languages[currentLanguage]?.about;

  const getSkillIcon = (skill) => {
    const iconMap = {
      'HTML5': '🌐',
      'CSS3': '🎨',
      'JavaScript': '⚡',
      'React': '⚛️',
      'Node.js': '🟢',
      'Express': '🚀',
      'MongoDB': '🍃',
      'MySQL': '🗄️',
      'Git': '📝',
      'GitHub': '🐙',
      'PHP': '🐘',
      'Python': '🐍',
      'Bootstrap': '📱',
      'WordPress': '📄',
      'Figma': '🎨',
      'Adobe Photoshop': '🖼️',
      'VS Code': '💻'
    };
    return iconMap[skill.name] || '⚡';
  };

  const getSkillColor = (level) => {
    const colorMap = {
      'Experto': { bg: '#dcfce7', color: '#166534', border: '#bbf7d0' },
      'Expert': { bg: '#dcfce7', color: '#166534', border: '#bbf7d0' },
      'Avanzado': { bg: '#dbeafe', color: '#1e40af', border: '#93c5fd' },
      'Advanced': { bg: '#dbeafe', color: '#1e40af', border: '#93c5fd' },
      'Intermedio': { bg: '#fef3c7', color: '#92400e', border: '#fed7aa' },
      'Intermediate': { bg: '#fef3c7', color: '#92400e', border: '#fed7aa' },
      'Básico': { bg: '#fee2e2', color: '#991b1b', border: '#fecaca' },
      'Basic': { bg: '#fee2e2', color: '#991b1b', border: '#fecaca' }
    };
    return colorMap[level] || colorMap['Básico'];
  };

  const getCategoryTitle = (category) => {
    const titles = {
      frontend: `🎨 ${getText('portfolio.skills.categories.frontend')}`,
      backend: `⚙️ ${getText('portfolio.skills.categories.backend')}`,
      database: `🗄️ ${getText('portfolio.skills.categories.database')}`,
      tools: `🛠️ ${getText('portfolio.skills.categories.tools')}`,
      design: `🎨 ${getText('portfolio.skills.categories.design')}`
    };
    return titles[category] || category;
  };

  return (
    <section className="skills-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{getText('portfolio.skills.title')}</span>
          <h2 className="section-title">{getText('portfolio.skills.subtitle')}</h2>
          <p className="section-description">
            {getText('portfolio.skills.subtitle')}
          </p>
        </div>

        <div className="skills-container">
          {Object.entries(portfolioData.skills).map(([category, categorySkills]) => (
            <div key={category} className="skill-category">
              <h3 className="category-title">
                {getCategoryTitle(category)}
              </h3>
              
              <div className="skills-grid">
                {categorySkills.map((skill, index) => {
                  const skillColor = getSkillColor(skill.level);
                  return (
                    <div key={index} className="skill-card">
                      <div className="skill-header">
                        <span className="skill-icon">{getSkillIcon(skill)}</span>
                        <div className="skill-info">
                          <h4 className="skill-name">{skill.name}</h4>
                          <span 
                            className="skill-level"
                            style={{
                              background: skillColor.bg,
                              color: skillColor.color,
                              border: `1px solid ${skillColor.border}`
                            }}
                          >
                            {skill.level}
                          </span>
                        </div>
                      </div>
                      
                      <div className="skill-bar">
                        <div 
                          className="skill-progress"
                          style={{ 
                            width: `${skill.percentage}%`,
                            background: `linear-gradient(135deg, ${skillColor.color}20 0%, ${skillColor.color}40 100%)`
                          }}
                        >
                          <span className="skill-percentage">{skill.percentage}%</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="skills-summary">
          <div className="summary-card">
            <div className="summary-icon">💡</div>
            <h3>{aboutData?.features?.items?.[3]?.title || getText('about.features.items.3.title')}</h3>
            <p>
              {aboutData?.features?.items?.[3]?.description || getText('about.features.items.3.description')}
            </p>
          </div>
          
          <div className="summary-card">
            <div className="summary-icon">🚀</div>
            <h3>{getText('portfolio.about.stats.experience')}</h3>
            <p>
              {getText('portfolio.experience.subtitle')}
            </p>
          </div>
          
          <div className="summary-card">
            <div className="summary-icon">🎯</div>
            <h3>{aboutData?.features?.items?.[0]?.title || getText('about.features.items.0.title')}</h3>
            <p>
              {aboutData?.features?.items?.[0]?.description || getText('about.features.items.0.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
